export default __webpack_public_path__ + "static/team-2-ef1a5adb023c8e85a34ff47d03963ea1.jpg";